// ช่องค้นหา ชื่อ / เบอร์โทร ของหน้ารายงาน (กรองในตารางฝั่งหน้าเว็บ ไม่ยิง API ใหม่)
// ใช้: mixins: [memberSearch] แล้วใส่ใน v-data-table
//   :search="memberSearch" :custom-filter="memberFilter"
// ดูทุกฟิลด์ของแถวที่ชื่อคีย์มี name / tel / phone / mobile (รวม object ซ้อนหนึ่งชั้น)
// เบอร์โทรเทียบเฉพาะตัวเลข: 081-234-5678, 0812345678, +66812345678 หาเจอเหมือนกัน
// ชื่อไลน์ตัวอักษรแต่ง (𝙾𝚞𝚖𝚄𝚗𝚐, ｆｕｌｌｗｉｄｔｈ) ถูก NFKC ให้เป็นตัวปกติก่อนเทียบ พิมพ์ oum ก็เจอ
const KEY_RE = /name|tel|phone|mobile/i

function fold (v) {
  const t = String(v)
  return (t.normalize ? t.normalize('NFKC') : t).toLowerCase()
}

function digitsOf (v) {
  const d = String(v).replace(/\D/g, '')
  return d.startsWith('66') && d.length === 11 ? '0' + d.slice(2) : d
}

function collect (item, out, depth) {
  if (!item || typeof item !== 'object') return out
  Object.keys(item).forEach(k => {
    const v = item[k]
    if (v == null) return
    if (typeof v === 'object') {
      if (depth < 1) collect(v, out, depth + 1)
    } else if (KEY_RE.test(k)) {
      out.push(String(v))
    }
  })
  return out
}

export default {
  data () {
    return {
      memberSearch: ''
    }
  },
  methods: {
    memberFilter (value, search, item) {
      const q = fold(search || '').trim()
      if (!q) return true
      const qDigits = /^[\d\s+()-]+$/.test(q) ? digitsOf(q) : ''
      return collect(item, [], 0).some(v =>
        fold(v).includes(q) || (qDigits !== '' && digitsOf(v).includes(qDigits))
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/memberSearch.js